// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29MAw","title":"styles_title__13r_b"};